"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreWatchers = exports.coreReducers = void 0;
const xuder_1 = require("@sonar-software/xuder");
const redux_1 = require("redux");
const selections_1 = require("./selections/index.js");
const customers_1 = require("./customers/index.js");
const data_dictionary_1 = require("./data-dictionary/index.js");
const data_security_1 = require("./data-security/index.js");
const followers_1 = require("./followers/index.js");
const initiatives_1 = require("./initiatives/index.js");
const timeline_legacy_1 = require("./timeline-legacy/index.js");
const onboarding_1 = require("./onboarding/index.js");
const organizations_1 = require("./organizations/index.js");
const sonar_objects_1 = require("./sonar-objects/index.js");
const stakeholders_1 = require("./stakeholders/index.js");
const tags_1 = require("./tags/index.js");
const timeline_1 = require("./timeline/index.js");
const users_1 = require("./users/index.js");
exports.coreReducers = (0, redux_1.combineReducers)({
    customers: customers_1.coreCustomersReducers,
    dataDictionary: data_dictionary_1.coreDataDictionaryReducers,
    dataSecurity: data_security_1.coreDataSecurityReducers,
    followers: followers_1.coreFollowersReducers,
    initiatives: initiatives_1.coreInitiativesReducers,
    onboarding: onboarding_1.coreOnboardingReducers,
    organizations: organizations_1.coreOrganizationsReducers,
    selections: selections_1.coreSelectionsReducers,
    sonarObjects: sonar_objects_1.coreSonarObjectsReducers,
    stakeholders: stakeholders_1.coreStakeholdersReducers,
    tags: tags_1.coreTagsReducers,
    timeline: timeline_1.coreTimelineReducers,
    timelineLegacy: timeline_legacy_1.coreLegacyTimelineReducers,
    users: users_1.coreUsersReducers
});
exports.coreWatchers = (0, xuder_1.combineAllWatchers)([
    customers_1.coreCustomersWatchers,
    data_dictionary_1.coreDataDictionaryWatchers,
    followers_1.coreFollowersWatchers,
    initiatives_1.coreInitiativesWatchers,
    onboarding_1.coreOnboardingWatchers,
    organizations_1.coreOrganizationsWatchers,
    data_security_1.coreDataSecurityWatchers,
    sonar_objects_1.coreSonarObjectsWatchers,
    stakeholders_1.coreStakeholdersWatchers,
    tags_1.coreTagsWatchers,
    timeline_1.coreTimelineWatchers,
    timeline_legacy_1.coreLegacyTimelineWatchers,
    users_1.coreUsersWatchers
]);
//# sourceMappingURL=index.js.map